import { Extension } from '@tiptap/core';
import { Plugin } from '@tiptap/pm/state';

// IDs are identities, not slugs: renaming/reordering never changes them. Missing
// and pasted duplicate IDs are repaired once. Idempotence bounds collaborative
// repairs: after a CRDT winner is received there is nothing more to dispatch.
export const DocumentHeadingId = Extension.create({
    name: 'documentHeadingId',
    addGlobalAttributes() { return [{ types: ['heading'], attributes: {
        id: { default: null, parseHTML: el => el.id || null, renderHTML: attrs => attrs.id ? { id: attrs.id } : {} },
    } }]; },
    addCommands() { return { setHeadingId: (id: string | null) => ({ commands }) => commands.updateAttributes('heading', { id }) }; },
    onCreate() { if (this.editor.isEditable) this.editor.view.dispatch(this.editor.state.tr.setMeta('ensureHeadingIds', true)); },
    addProseMirrorPlugins() {
        const editor = this.editor;
        return [new Plugin({ appendTransaction(transactions, _old, state) {
            if (!editor.isEditable || !transactions.some(tr => tr.docChanged || tr.getMeta('ensureHeadingIds'))) return null;
            const seen = new Set<string>();
            const tr = state.tr;
            state.doc.descendants((node, pos) => {
                if (node.type.name !== 'heading') return;
                let id = node.attrs.id as string | null;
                if (!id || seen.has(id)) {
                    id = `heading-${crypto.randomUUID()}`;
                    tr.setNodeMarkup(pos, undefined, { ...node.attrs, id });
                }
                seen.add(id);
            });
            return tr.docChanged ? tr.setMeta('addToHistory', false) : null;
        } })];
    },
});
